export default "__VITE_ASSET__CNQp8iXD__"